import React from "react";
import {Link, Outlet, useLocation} from "react-router-dom";
import {Container, Nav} from "react-bootstrap";
import {useWindowSize} from "../hooks";

export function ResponsiveNavTabs({children}) {
    const {width} = useWindowSize();

    const location = useLocation();

    const tabs = children instanceof Array ? children : [children];

    return (
        width < 576 ?
            <Container className="pb-5 mb-2">
                {tabs.length > 1 &&
                    <Nav justify variant="underline" activeKey={location.pathname}>
                        {tabs.map((child, index) => (
                            child && child.type(child.props) && <Nav.Item key={index}>{child}</Nav.Item>
                        ))}
                    </Nav>
                }
                <Outlet/>
            </Container>
            :
            <Container fluid="lg" className="pt-2">
                {tabs.length > 1 ?
                    <Nav justify={false} variant="underline" activeKey={location.pathname}>
                        {tabs.map((child, index) => (
                            child && child.type(child.props) && <Nav.Item key={index}>{child}</Nav.Item>
                        ))}
                    </Nav>
                    :
                    <Nav justify={false} variant="underline" activeKey={location.pathname}></Nav>
                }
                <Outlet/>
            </Container>
    )
}

export function ResponsiveNavTab({to, icon, title, variant = "primary", show = true, disabled = false}) {

    const eventKey = to.hasOwnProperty("pathname") ? to.pathname : to

    if (show)
        return <Nav.Link as={Link} to={to} eventKey={eventKey} disabled={disabled} className={`text-${variant}`}>{icon} <span
            className="d-none d-sm-inline">{title}</span></Nav.Link>
    return null
}

export function ResponsiveContent({body}) {
    const {width} = useWindowSize();
    if (width < 576)
        return <div className="py-2">{body}</div>
    else
        return <div className="p-2">{body}</div>
}
